 /***********************************************************
Sticky Product Detail Content
***********************************************************/
// function evaluateStickyProductDetail() {
//   const detailEl = document.querySelector('.product-detail__content');

//   if (!detailEl) return;

//   const contentHeight = detailEl.offsetHeight;
//   const viewportHeight = window.innerHeight;

//   console.log('contentHeight = ' + contentHeight);
//   console.log('viewport = ' + viewportHeight);

//   if (contentHeight < viewportHeight) {
//     detailEl.classList.add('is-sticky');
//   } else {
//     detailEl.classList.remove('is-sticky');
//   }
// }

// function initStickyProductDetail() {
//   evaluateStickyProductDetail();
//   window.addEventListener('resize', evaluateStickyProductDetail);
// }

// shopify-sticky.js
/***********************************************************
Sticky Product Detail Content (ScrollSmoother-friendly)
***********************************************************/
let productDetailPinST; // keep a reference so we can kill/recreate

function setupProductDetailPin() {
  const detailEl = document.querySelector('.product-detail__content');
  if (!detailEl) return;

  const viewportHeight = window.innerHeight;
  const contentHeight  = detailEl.offsetHeight;

  // Kill any previous ST instance before re-creating
  if (productDetailPinST && productDetailPinST.kill) productDetailPinST.kill();

  // Only pin if shorter than viewport
  if (contentHeight < viewportHeight && window.gsap && window.ScrollTrigger) {
    const header = document.querySelector('.header');
    const headerOffset = header ? header.offsetHeight : 0;

    productDetailPinST = ScrollTrigger.create({
      trigger: detailEl,
      start: `top top+=${headerOffset}`,     // leave room for a fixed/hidden header
      end: () => `+=${viewportHeight - contentHeight}`, // stop when bottom would hit
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true
    });
  }
}

function initStickyProductDetail() {
  setupProductDetailPin();
  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();   // ensures measurements update
    setupProductDetailPin();   // re-evaluate pin condition
  });

  // If using Shopify Theme Editor live reloads:
  document.addEventListener('shopify:section:load', () => {
    ScrollTrigger.refresh();
    setupProductDetailPin();
  });
  document.addEventListener('shopify:section:reorder', () => {
    ScrollTrigger.refresh();
    setupProductDetailPin();
  });
}

document.addEventListener('DOMContentLoaded', initStickyProductDetail);
